import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { RayCodeAction } from '../../actions';
import { RayForm, RayFormValidation } from '../common';
import { Translate as t } from '../../config/Translate';
import { useConfirmDialog } from '../common/ConfirmDialog';
import { EditSaveCancelBar } from '../common/Buttons';
import { useBatchEdit } from '../../hooks/useBatchEdit';

// 편집 칸 — 서버 값 → 입력 draft. isbuiltin 은 체크 즉시 저장이라 뺀다.
const toDraft = (r) => ({
	type: r?.type, group: r?.group, code: r?.code, name: r?.name, category: r?.category,
	datatype: r?.datatype, alias: r?.alias, sortnumber: r?.sortnumber,
});

const RayCodeAdd = ({ raycode, Update, Create, Delete, callback }) => {
	const { confirm, dialog } = useConfirmDialog();

	const user = JSON.parse(localStorage.getItem('user'));
	const devadmin = user.adminid == "sungwon.bang";
	const [errors, setErrors] = useState([]);
	const [isUp, setIsUp] = useState(false);
	const [isDel, setIsDel] = useState(false);
	const [editable, setEditable] = useState(true);
	const isNew = !raycode._id;
	const { draft: item, editing, saving, errors: editErrors, formKey, onChange, onEdit, onSave, onCancel } = useBatchEdit({
		source: raycode,
		toDraft,
		save: (changed) => Update(raycode._id, changed),
		editable,
	});
	const fieldEditable = editable && (isNew || editing);

	useEffect(() => {
		if (isDel && !raycode._id) {
			setIsDel(false);
			callback();
		}
		if (raycode.isbuiltin)
			setEditable(devadmin || false);
	}, [raycode])

	const form_controls = [
		{
			title: '',
			items: [
				{ type: 'input', name: 'type', label: t('common.field.type'), val: item.type, required: true, isEditable: fieldEditable },
				{ type: 'input', name: 'group', label: t('common.label.group'), val: item.group, isEditable: fieldEditable },
				{ type: 'input', name: 'code', label: t('common.field.code'), val: item.code, required: true, isEditable: fieldEditable },
				{ type: 'input', name: 'name', label: t('common.field.name'), val: item.name, required: true, isEditable: fieldEditable },
				{ type: 'input', name: 'category', label: t('common.label.category'), val: item.category, isEditable: fieldEditable },
				{
					type: 'select2', name: 'datatype', label: 'Data Type', val: item.datatype || "STRING", isEditable: fieldEditable, list: [
						{ code: "STRING", title: "String" },
						{ code: "DATETIME", title: "DateTime" },
						{ code: "BOOLEAN", title: "True/False" },
					]
				},
				{ type: 'select2add', name: 'alias', label: 'Alias', val: item.alias || [], isEditable: fieldEditable, isMulti: true, list: [] },
				{ type: 'number', name: 'sortnumber', label: 'Sort Number', val: item.sortnumber || 0, isEditable: fieldEditable },
			],
		},
	];
	if (devadmin) {
		form_controls[0].items.push(
			// Build-In 체크 즉시 저장은 기존 항목에서만. 신규 등록 폼에서는 입력값으로 두고 [추가] 때 함께 보낸다.
			{ type: 'checkbox', name: 'isbuiltin', label: 'Build-In', val: isNew ? item.isbuiltin : raycode.isbuiltin, isEditable: editable, ...(isNew ? {} : { action: Update }) },
		);
	}

	const validAdd = () => {
		const errValidate = RayFormValidation(form_controls, item);
		if (errValidate.length > 0) {
			setErrors(errValidate);
		} else {
			setIsUp(true);
			Create({ ...raycode, ...item });
		}
	};

	const del = async () => {
		if (await confirm({ message: t('common.message.confirm.delete'), danger: true })) {
			setIsDel(true);
			Delete(raycode._id);
		}
	}

	console.log("raycode", raycode);

	return (
		<>
			{dialog}
			{raycode._id && <RayForm key={formKey} controls={form_controls} showAllFields={true} handleChangeData={onChange} errors={editErrors} actionkey={raycode._id} />}
			{!raycode._id && <RayForm controls={form_controls} isForm={true} handleChangeData={onChange} errors={errors} />}
			{(editable || (!editable && devadmin)) && <div className="section">
				{raycode._id && <EditSaveCancelBar canEdit={editable} editing={editing} onEdit={onEdit} onSave={() => onSave(form_controls)} onCancel={onCancel} saving={saving} className="me-1" />}
				{raycode._id && <button className="btn btn-danger text-white" onClick={() => del()}>{t('common.button.delete')}</button>}
				{!raycode._id && <button className="btn btn-primary" onClick={() => validAdd()}>{t('common.button.add')}</button>}
				<button className="btn btn-default" onClick={() => callback()}>{t('common.button.cancel')}</button>
			</div>}
		</>
	)
};

const mapState = (state) => {
	const raycode = state.RayCodeReducer.item;
	return { raycode };
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(RayCodeAction.Update(_id, data)),
	Delete: (_id) => dispatch(RayCodeAction.Delete(_id)),
	Create: (data) => dispatch(RayCodeAction.Create(data)),
});

export default connect(mapState, mapDispatch)(RayCodeAdd);
